import React, {Fragment} from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import StyledTypography from "../common/StyledTypography";
import PropTypes from "prop-types";
import ViewButton from "../common/viewButton";
import handleNavigate from "../common/customFunctions/handleNavigate";

export default function TicketsTableRow({row, handleClick, isItemSelected}) {
    const timezoneMins = useSelector(({timezone}) => timezone);
    const navigate = useNavigate();
    // console.log(row)
    const handleView = () => {
        handleNavigate(event, navigate, `/ticketView?ticketId=${row.ticket_header_uid}`);
    };

    return (
        <Fragment>
            <TableRow hover onClick={(event) => handleClick(event, row.ticket_number)} role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={row.ticket_number} selected={isItemSelected} sx={{cursor: "pointer"}}>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{row.ticket_number}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{row.status}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{row.operation.full_name}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{`${row.assigned_to_person.firstname} ${row.assigned_to_person.lastname}`}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{row.template.name}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{moment.utc(row.created_timestamp).add(timezoneMins, "minutes").format("YYYY-MM-DD HH:mm")}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <StyledTypography variant="subtitle2">{moment.utc(row.updated_timestamp).add(timezoneMins, "minutes").format("YYYY-MM-DD HH:mm")}</StyledTypography>
                </TableCell>
                <TableCell align="left">
                    <ViewButton onClick={handleView} />
                </TableCell>
            </TableRow>
        </Fragment>
    );
}
TicketsTableRow.propTypes = {
    row: PropTypes.object.isRequired,
    handleClick: PropTypes.func,
    isItemSelected: PropTypes.number
};
